import LegalPage from "components/LegalPage";

const TermsOfService = () => {
  return <LegalPage page="terms-of-service" />;
};

export default TermsOfService;
